import React from "react";
import { Dot, SkeletonLoader } from "@activecollab/components";

const NewFeatureSkeleton = () => {
  return (
    <div className="tw-flex tw-py-2 tw-items-start">
      <div className="tw-flex tw-items-center tw-justify-end tw-w-32 tw-gap-3 tw-px-3 tw-shrink-0">
        <SkeletonLoader />
        <Dot
          size={4}
          color="#89898E"
        />
      </div>
      <div className="tw-flex tw-flex-col tw-gap-2 tw-max-w-[640px] tw-w-full">
        <div className="tw-flex tw-flex-col tw-gap-3">
          <SkeletonLoader className="tw-w-full" />
          <SkeletonLoader className="tw-w-full" />
          <SkeletonLoader className="tw-w-full" />
        </div>
      </div>
    </div>
  );
};

NewFeatureSkeleton.displayName = "NewFeatureSkeleton";

export default NewFeatureSkeleton;
